const SDK_VERSION = '8.18.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
